import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryRuntime extends EventRegistryCategory {
    label = 'Runtime';
    constructor(parent) {
        super(parent);
        super.init();
    }
    globalkeydown = () => new EventRegistryItem({
        handlerName: 'onGlobalKeyDown',
        params: { core: ['keyboardKey'] },
    });
}
